// 权限相关
const permission = require('./permission');
// 默认模板ID
const DEFAULT_TEMPLATE = 'ff';
// 视图筛选 未设置
const FILTER_UNSET = '_filter_unset';
// 用户支持空间ID
const SUPPORT_SPACE = 'ed798ada0c6111eb9a4a7cd30ab8a430';
// 外部负责人标识
const EXTERNAL_OWNER = 'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF';
// 级联属性连接符
const CASCADE_CONNECTOR = 'b29846108d244671bce91f1a59316a9e';
// 模板库空间ID
const LIBRARY_ORG = '3A0328AC0FA311EB9A4A7CD30AB8A430';
const LIBRARY_ORG_NEW = ['3A0328AC0FA311EB9A4A7CD30AB8A430'];
// 模板库空间根节点ID
const LIBRARY_ORG_ROOT = 'a59e4ff4eb34407f97ff05777e2395e3';
const LIBRARY_ORG_ROOT_NEW = {
  '3A0328AC0FA311EB9A4A7CD30AB8A430': 'a59e4ff4eb34407f97ff05777e2395e3',
};

// 默认用户头像
const DEFAULT_AVATAR = 'https://www.mylinkpi.com/webImg/user_default.png';

const DEFAULT_STATUS_PROP = [
  {
    name: '负责人',
    type: 'user',
    display: false,
    multiple: false,
    required: true,
    defaultValue: 'updater',
  },
  {
    name: '参与者',
    type: 'user',
    display: false,
    multiple: true,
    required: false,
  },
  {
    name: '开始时间',
    type: 'datetime',
    display: false,
    multiple: false,
    required: false,
    defaultValue: 'updateTime',
  },
  {
    name: '结束时间',
    type: 'datetime',
    display: false,
    multiple: false,
    required: false,
  },
  {
    name: '备注',
    type: 'text',
    multiple: false,
    required: false,
    display: false,
  },
];
// 默认模板
const DEFAULT_TEMPLATE_INSTANCE = {
  id: 0,
  template_id: DEFAULT_TEMPLATE,
  prop: [],
  name: '系统主题',
  task_status: [
    { icon: 'iconlinggan', prop: DEFAULT_STATUS_PROP, name: '笔记' },
    {
      prevState: 0,
      icon: 'iconzhunweixingdong',
      prop: DEFAULT_STATUS_PROP.map((x) => {
        return { ...x, display: true };
      }),
      name: '待办',
    },
    {
      prevState: 1,
      icon: 'iconwanchengxingdong',
      prop: DEFAULT_STATUS_PROP,
      name: '完成',
      isFinal: true,
    },
  ],
};
// 默认模板 个人空间
const DEFAULT_TEMPLATE_INSTANCE_PERSONAL = {
  id: 0,
  template_id: DEFAULT_TEMPLATE,
  prop: [],
  name: '系统主题',
  task_status: [
    { icon: 'iconlinggan', prop: DEFAULT_STATUS_PROP, name: '笔记' },
    {
      prevState: 0,
      icon: 'iconzhunweixingdong',
      prop: [
        {
          name: '负责人',
          type: 'user',
          display: true,
          multiple: false,
          required: true,
          defaultValue: 'updater',
        },
        {
          name: '参与者',
          type: 'user',
          display: false,
          multiple: true,
          required: false,
        },
        {
          name: '开始时间',
          type: 'datetime',
          display: true,
          multiple: false,
          required: false,
          defaultValue: 'updateTime',
        },
        {
          name: '结束时间',
          type: 'datetime',
          display: true,
          multiple: false,
          required: false,
        },
      ],
      name: '待办',
    },
    {
      prevState: 1,
      icon: 'iconwanchengxingdong',
      prop: DEFAULT_STATUS_PROP,
      name: '完成',
      isFinal: true,
    },
  ],
};
/**
 * 侧边栏模式
 */
const SIDE_MODE = {
  /**
   * 主题
   */
  TREE: 'tree',
  /**
   * 时刻
   */
  TIMELINE: 'timeline',
  /**
   * 回收站
   */
  RECYCLEBIN: 'recyclebin',
  /**
   * 收藏
   */
  FOCUS: 'focus',
  /**
   * 通知 deprecated!
   */
  NOTICE: 'notice',
  /**
   * 最近
   */
  RECENTLY: 'recently',
  /**
   * 消息
   */
  CHAT: 'chat',
  /**
   * 模版广场
   */
  THEMESQUARE: 'themesquare',
  // 草稿箱
  DRAFTSBOX: 'draftsbox',
  // 通讯录
  CONTACTS: 'contacts',
};
// 主题颜色标签
const ACTION_COLORS = ['#3E8FF9', '#9270FC', '#19BD83', '#F4A723', '#F15643'];
// 空间颜色标签
const SPACE_TAG_COLORS = ['#3E8FF9', '#9270FC', '#19BD83', '#F4A723', '#F15643'];

// 首页iconfont对应的颜色
const HOME_ICON_COLOR = {
  default: '#316EF5',
  iconView_kanban: '#877AE9',
  iconView_table: '#67C2B7',
  iconView_Statistic: '#FDB15E',
  iconView_topic: '#316EF5',
  iconView_calendar: '#70BFF3',
};
// 首页iconfont对应的背景颜色
const HOME_ICON_BACKGROUND_COLOR = {
  default: '#EEF3FE',
  iconView_kanban: '#F1F0FC',
  iconView_table: '#ECF7F6',
  iconView_Statistic: '#FEF4E8',
  iconView_topic: '#EEF3FE',
  iconView_calendar: '#F0F8FD',
};
// 首页类型对应的图标
const HOME_ICON_TYPE = {
  default: 'iconView_topic',
  board: 'iconView_kanban',
  table: 'iconView_table',
  chart: 'iconView_Statistic',
  topic: 'iconView_topic',
};
// 模板状态图标颜色及背景色、unicode
const STATUS_ICON = {
  default: {
    color: '#6B7A96',
    backgroundColor: '#EFF0F1',
    unicode: '&#xe649;',
  },
  iconlinggan: {
    color: '#6B7A96',
    backgroundColor: '#EFF0F1',
    unicode: '&#xe649;',
  },
  iconzhunweixingdong: {
    color: '#6B7A96',
    backgroundColor: '#EFF0F1',
    unicode: '&#xe61c;',
  },
  iconwanchengxingdong: {
    color: '#6890EB',
    backgroundColor: '#6890EB26',
    unicode: '&#xe61f;',
  },
  iconicon_shenhetongguo: {
    color: '#11C5A7',
    backgroundColor: '#11C5A726',
    unicode: '&#xe68a;',
  },
  iconicon_chexiao: {
    color: '#8A919E',
    backgroundColor: '#8A919E26',
    unicode: '&#xe689;',
  },
  iconstatus_zanting: {
    color: '#8A919E',
    backgroundColor: '#8A919E26',
    unicode: '&#xe6fc;',
  },
  iconicon_daiqueren: {
    color: '#FFA02F',
    backgroundColor: '#FFA02F26',
    unicode: '&#xe688;',
  },
  iconstatus_jingshi: {
    color: '#FFA02F',
    backgroundColor: '#FFA02F26',
    unicode: '&#xe6fa;',
  },
  iconquxiao: {
    color: '#F85789',
    backgroundColor: '#F8578926',
    unicode: '&#xe68b;',
  },
  iconstatus_zusai: {
    color: '#F85789',
    backgroundColor: '#F8578926',
    unicode: '&#xe6fb;',
  },
  iconzhuangtai_biji_shixin: {
    color: '#6B7A96',
    backgroundColor: '#EFF0F1',
    unicode: '&#xe792;',
  },
  iconzhuangtai_yiwancheng_shixin: {
    color: '#11C5A7',
    backgroundColor: '#11C5A726',
    unicode: '&#xe793;',
  },
  iconzhuangtai_daiqueren_shixin: {
    color: '#FFA02F',
    backgroundColor: '#FFA02F26',
    unicode: '&#xe794;',
  },
  iconzhuangtai_daiwancheng_shixin: {
    color: '#6890EB',
    backgroundColor: '#6890EB26',
    unicode: '&#xe795;',
  },
  iconzhuangtai_zusai_shixin: {
    color: '#F85789',
    backgroundColor: '#F8578926',
    unicode: '&#xe796;',
  },
  iconzhuangtai_zanting_shixin: {
    color: '#8A919E',
    backgroundColor: '#8A919E26',
    unicode: '&#xe797;',
  },
  iconzhuangtai_chexiao_shixin: {
    color: '#8A919E',
    backgroundColor: '#8A919E26',
    unicode: '&#xe798;',
  },
  iconzhuangtai_guanbi_shixin: {
    color: '#F85789',
    backgroundColor: '#F8578926',
    unicode: '&#xe799;',
  },
  iconzhuangtai_daijiejue_shixin: {
    color: '#6B7A96',
    backgroundColor: '#EFF0F1',
    unicode: '&#xe79a;',
  },
  iconzhuangtai_jingshi_shixin: {
    color: '#FFA02F',
    backgroundColor: '#FFA02F26',
    unicode: '&#xe79b;',
  },
};
// 获取iconfont对应的颜色
const getTempStatusIconColor = (iconfontClassname) => {
  return (STATUS_ICON[iconfontClassname] || STATUS_ICON['default']).color;
};

// 节点类型
//            0 ; 普通
//            1 ; 回收站
//            2 ; 待整理
//            3 ; 过滤器根节点
//            4 ; 过滤器路径节点
//            5 ; 过滤器叶子节点
const NODE_TYPE = {
  NORMAL: 0,
  // 回收站
  RECYCLEBIN: 1,
  // 待整理
  CLEARING: 2,
  // 过滤器根节点
  FILTERNODE_ROOT: 3,
  // 过滤路径
  FILTERNODE_PATH: 4,
  // 过滤叶子
  FILTERNODE_LEAF: 5,
};

const INTRO_MASK = {
  剪切粘贴: 0x0000000000000001,
  展开主题: 0x0000000000000002,
  两个主题: 0x0000000000000004,
  添加节点: 0x0000000000000008,
  钻入主题: 0x0000000000000010,
  点击关注: 0x0000000000000020,
};

const FUNCTION_SET = {
  CUSTOM_PROP: 0x0000000000000001,
  VIEW: 0x0000000000000002,
  COMMENT: 0x0000000000000004,
  NODE_LINK: 0x0000000000000008,
  CLEARING: 0x0000000000000010,
  INHERIT_PROP: 0x0000000000000020,
  SHOW_REQUIRED_PROP: 0x0000000000000040,
  TEMPLATE_FIRST: 0x0000000000000080,
  OWNER_VIEW: 0x0000000000000100,
  ALL_EXPORT: 0x0000000000000200,
};

const ORG_SET = {
  NEED_NAME: 0x0000000000000001,
};

const GUIDES = {
  剪切粘贴: '按住拖拽主题，可以修改主题层级。',
  展开主题: '点击小圆点，可钻入主题。',
  两个主题: '按Tab，缩进此主题；Shift+Tab，缩出此主题。',
  添加节点: '按Enter可以新增兄弟主题',
  钻入主题: '点击<， 返回上层',
  点击关注: '点击查看通知提醒',
};

const CURRENCIES = [
  {
    type: 'CNY',
    name: '人民币',
    symbol: 'CN¥',
  },
  {
    type: 'USD',
    name: '美元',
    symbol: '$',
  },
  {
    type: 'EUR',
    name: '欧元',
    symbol: '€',
  },
  {
    type: 'GBP',
    name: '英镑',
    symbol: '£',
  },
  {
    type: 'JPY',
    name: '日元',
    symbol: '¥',
  },
];

const CURRENCY_PRECISION = [
  {
    label: '1',
    value: 0,
  },
  {
    label: '1.0',
    value: 1,
  },
  {
    label: '1.00',
    value: 2,
  },
];

const NUMBER_PRECISION = [
  {
    label: '1',
    value: 0,
  },
  {
    label: '1.0',
    value: 1,
  },
  {
    label: '1.00',
    value: 2,
  },
  {
    label: '1.000',
    value: 3,
  },
  {
    label: '1.0000',
    value: 4,
  },
];

const FORMULA_OPERATOR = [
  {
    label: '+',
    value: 'add',
  },
  {
    label: '-',
    value: 'subtract',
  },
  {
    label: '*',
    value: 'multiply',
  },
  {
    label: '/',
    value: 'divide',
  },
];

const FORM_LAYOUT_5 = {
  labelCol: {
    span: 5,
  },
  wrapperCol: {
    span: 19,
  },
};

const FORM_LAYOUT_7 = {
  labelCol: {
    span: 7,
  },
  wrapperCol: {
    span: 13,
  },
};

/**
 * 主题类型的状态
 * 1 锁定
 * 2 停用
 * 3 删除 // 其实只是隐藏，不是彻底删除
 * 0 正常状态
 * 目前还没删除
 */
const THEME_STATUS = {
  lock: 1,
  init: 0,
  stop: 2,
  del: 3,
};
// 条件匹配引用方式
const MATCHING_TYPES = [
  {
    label: '自动匹配原值',
    value: 0,
  },
  {
    label: '求和',
    value: 1,
  },
  {
    label: '求平均值',
    value: 2,
  },
  {
    label: '最大值',
    dateLabel: '最晚日期',
    value: 3,
  },
  {
    label: '最小值',
    dateLabel: '最早日期',
    value: 4,
  },
  {
    label: '计数',
    value: 5,
  },
  {
    label: '获取选值范围',
    value: -1,
  },
];

const PROP_TYPE = {
  user: {
    label: '人员',
    icon: 'iconattribute_contacts',
    unicode: '&#xe72f;',
  },
  enum: {
    label: '选值',
    icon: 'iconattribute_selected_value',
    unicode: '&#xe712;',
  },
  tag: {
    label: '选值',
    icon: 'iconattribute_selected_value',
    unicode: '&#xe712;',
  },
  date: {
    label: '日期',
    icon: 'iconattribute_calendar',
    unicode: '&#xe730;',
  },
  datetime: {
    label: '时间',
    icon: 'iconattribute_time',
    unicode: '&#xe731;',
  },
  currency: {
    label: '货币',
    icon: 'iconattribute_currency',
    unicode: '&#xe710;',
  },
  datetimeRange: {
    label: '时间段',
    icon: 'iconattribute_time',
    unicode: '&#xe731;',
  },
  currencyV2: {
    label: '货币',
    icon: 'iconattribute_currency',
    unicode: '&#xe710;',
  },
  number: {
    label: '数字',
    icon: 'iconattribute_number',
    unicode: '&#xe71a;',
  },
  text: {
    label: '文本',
    icon: 'iconattribute_text',
    unicode: '&#xe713;',
  },
  quote: {
    label: '引用',
    icon: 'iconattribute_quote',
    unicode: '&#xe70f;',
  },
  formula: {
    label: '公式',
    icon: 'icongongshi',
    unicode: '&#xe77c;',
  },
  attachment: {
    label: '附件',
    icon: 'iconfujian1',
    unicode: '&#xe77d;',
  },
  cascade: {
    label: '多级选值',
    icon: 'iconduojixuanzhi',
    unicode: '&#xe77e;',
  },
  positioning: {
    label: '定位',
    icon: 'icona-dingwei1',
    unicode: '&#xe76e;',
  },
  auto_inc: {
    label: '自增ID',
    icon: 'iconzizengID',
    unicode: '&#xe7a6;',
  },
  address: {
    label: '地址',
    icon: 'iconAddress',
    unicode: '&#xe7c6;',
  },
  department: {
    label: '部门',
    icon: 'iconProp_Department',
    unicode: '&#xe813;',
  },
};

/**
 * 系统用户 小连 小派等
 * @type {string[]}
 */
const SYSTEM_USERS =
  globalThis?.window?.location?.host && window?.location?.host.startsWith('test05.')
    ? []
    : [
        '8C8C4C293B0111EC8C496C92BF5C7582',
        '2EDF27C53B0211EC8C496C92BF5C7582',
        'D3938C23FE5A11EC8C496C92BF5C7582',
      ];

module.exports = {
  ...permission,
  DEFAULT_AVATAR,
  SIDE_MODE,
  ACTION_COLORS,
  SPACE_TAG_COLORS,
  NODE_TYPE,
  INTRO_MASK,
  GUIDES,
  FUNCTION_SET,
  ORG_SET,
  CURRENCIES,
  getTempStatusIconColor,
  DEFAULT_TEMPLATE,
  SUPPORT_SPACE,
  DEFAULT_TEMPLATE_INSTANCE,
  DEFAULT_TEMPLATE_INSTANCE_PERSONAL,
  EXTERNAL_OWNER,
  FILTER_UNSET,
  CURRENCY_PRECISION,
  FORM_LAYOUT_5,
  FORM_LAYOUT_7,
  LIBRARY_ORG,
  LIBRARY_ORG_NEW,
  HOME_ICON_TYPE,
  HOME_ICON_COLOR,
  HOME_ICON_BACKGROUND_COLOR,
  STATUS_ICON,
  NUMBER_PRECISION,
  FORMULA_OPERATOR,
  THEME_STATUS,
  MATCHING_TYPES,
  PROP_TYPE,
  CASCADE_CONNECTOR,
  DEFAULT_STATUS_PROP,
  LIBRARY_ORG_ROOT,
  LIBRARY_ORG_ROOT_NEW,
  SYSTEM_USERS,
};
